import { render } from "./NoticeDtlPage.vue?vue&type=template&id=327b0b7b&lang=true"
import script from "./NoticeDtlPage.vue?vue&type=script&lang=js"
export * from "./NoticeDtlPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__